import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ContractConditions } from '@models/contract-conditions';
import { CONTRACT_START_TOO_EARLY } from '../../../config/error-messages.const';
import { CommonValidators } from '../../../shared/validators/common-validators';
import { findViableContractStartDate } from '../../../utils/helper.functions';
import { OrderStepBaseComponent } from '../../order-step-base-component';
import { OrderState } from 'app/order/models/order-state.model';

@Component({
    selector: 'app-contract-period',
    templateUrl: './contract-period.component.html',
    styleUrls: ['./contract-period.component.scss'],
    standalone: false,
})
export class ContractPeriodComponent extends OrderStepBaseComponent<Pick<OrderState, 'contract'>> {
    // #region errormessages
    public contractStartErrorMessages = {
        ageTooHigh: CONTRACT_START_TOO_EARLY,
    };
    protected contractPeriodErrorMessages = 'Bitte wähle die gewünschte Laufzeit aus.';
    // #endregion

    public contractPeriodOptions: { label: string; value: number }[] = [];

    public constructor(private formBuilder: FormBuilder) {
        super();
        this.initOptions();
        this.initForm();
    }

    public get contract(): Partial<ContractConditions> | undefined {
        return this.state?.contract;
    }

    public handleStateChange(): void {
        if (typeof this.contract?.contractPeriod === 'number') {
            this.form.get('contractPeriod').patchValue(this.contract.contractPeriod);
        }
        if (this.contract?.contractStart) {
            this.form.patchValue({ contractStart: this.contract.contractStart });
        } else {
            this.form.patchValue({
                contractStart: findViableContractStartDate(this.product()?.orderConfig?.contractStartMode),
            });
        }
        if (this.product()?.orderConfig?.contractStartMode === 'month') {
            this.form
                .get('contractStart')
                .setValidators([Validators.required, Validators.pattern(/^([0-9]{2}\.){2}[0-9]{4}$/)]);
        } else {
            this.form.get('contractStart').setValidators(CommonValidators.birthday(-1, 0));
        }
        this.form.get('contractStart').updateValueAndValidity();
    }

    private initForm(): void {
        this.form = this.formBuilder.group({
            contractPeriod: [null, Validators.required],
            contractStart: [null, CommonValidators.birthday(-1, 0)],
        });
    }

    private initOptions(): void {
        for (let i = 1; i < 13; i++) {
            this.contractPeriodOptions.push({
                label: `${i} Monat${i > 1 ? 'e' : ''}`,
                value: i,
            });
        }
    }

    public getData(): Partial<OrderState> {
        return {
            contract: {
                ...this.contract,
                contractPeriod: this.form.get('contractPeriod').value,
                contractStart: this.form.get('contractStart').value,
            },
        };
    }
}
